<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('record.cbjl')}}</div>
        </div>
        <div class="cotainer">
             <ul class="item-box" @scroll="listenScroll">
                <li class="item" v-for="(item,index) in list" :key="index">
                    <img class="img" src="@/assets/new/chongbi2.png" alt="">
                    <div class="item-right">
                        <div class="item-head">
                            <div class="item-lt">
                                <div class="t1">{{ item.currency }}</div>
                                <div class="time">{{ item.add_time | timeGs }}</div>
                            </div>
                            <div class="item-rt">
                                <div class="t2">{{ item.money }}</div>
                                <div class="status" :class="{under: item.status == 0}">{{item.status | status}}</div>
                            </div>
                        </div>
                        <div class="remark"  v-show="item.status == -1">{{ item.remark_re }}</div>
                    </div>
                </li>
                <!-- 暂无数据 -->
                <no-data v-show="isNoData"></no-data>
            </ul>
            <img id="goTop" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/top.png" alt="">
        </div>
    </div>
</template>
<script>
import noData from '@/components/noData.vue'
import VueBetterScroll from 'vue2-better-scroll'
let that;
export default {
    name: 'cbjl',
    data () {
        return {
            tabIdx: 0,
            isNoData: false,
            list: [],
            statusText: [],
            isGoTOP: false,
            curDataLength: 10,
            theme: false,
            page: 1,
            limit: 10,
            timestamp: 0
        }
    },
    beforeCreate() {
        that = this;
    },
    created(){
        this.tabIdx = this.$route.query.idx || 0;
        this.statusText = this.$t('status.statusText');
        this.theme = JSON.parse(localStorage.getItem('theme'))
    },
    mounted() {
        this.getMyLog()
    },
    methods: {
        goTop(){
           $('.item-box').animate({scrollTop:'0px'},'slow');
        },
        getMyLog(){
            let url = '/web/rechargeLog';
            let params = {
                page: this.page
            }
            this.$ajax.get(url,{params}).then((res) => {
                if(res.data.code == 0){
                  let resData = res.data.data.data;
                  if(resData.length > 0){
                    this.list = this.list.concat(resData);
                      this.curDataLength = resData.length;
                  }else{
                      this.curDataLength = resData.length;
                  }
                  if(this.list.length > 0){
                      this.isNoData = false;
                  }else{
                      this.isNoData = true;
                  }
                }else{
                  this.$router.push('/index')
                }
            }).catch(function(err){
                console.log(err)
            })
       },
       listenScroll(e) {  //监听滚动
            let ele = e.srcElement ? e.srcElement : e.target;
            if(ele.scrollTop > 200){
                this.isGoTOP = true
            }else{
                this.isGoTOP = false
            }
            if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
                if(this.curDataLength > 0){
                    this.page ++;
                    this.getMyLog();
                }
            }
        },
        goBack(){
            this.$router.go(-1);
        },
    },
    filters: {
        status: function(val){
            if(val == -1){
                return that.statusText[0]
            }else if(val == 0){
                return that.statusText[1]
            }else if(val == 1){
                return that.statusText[2]
            }else{
                return that.statusText[0]
            }
        }
    },
    components:{
        noData,
        VueBetterScroll
    }
}
</script>
<style scoped>
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .32rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .32rem;
        height: .6rem;
    }
    .head .icon2{
        position: absolute;
        top: 50%;
        right: .1rem;
        width: .42rem;
        height: .45rem;
        transform: translate(-50%,-50%);
    }
   .cotainer .item-box{
        position: absolute;
        top: 1.3rem;
        bottom: 0;
        width: 100%;
        overflow-y: scroll;
    }
    .cotainer .item-box .item{
        display: flex;
        align-items: stretch;
        padding: .6rem .3rem 0 .3rem;
    }
    .cotainer .item-box .item .img{
        width: .68rem;
        height: .68rem;
        margin-right: .3rem;
    }
    .cotainer .item-box .item .item-right{
        flex: 1;
        padding-bottom: .4rem;
        border-bottom: 1px solid #313a47;
    }
    .cotainer .item-box .item .item-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .cotainer .item-box .item .t1{
        color: #fff;
        font-size: .48rem;
    }
    .cotainer .item-box .item .t2{
        color: #fff;
        font-size: .52rem;
        text-align: right;
    }
    .cotainer .item-box .item .time{
        padding-top: .36rem;
        color: #797979;
        font-size: .4rem;
    }
    .cotainer .item-box .item .status{
        padding-top: .36rem;
        color: #575757;
        font-size: .4rem;
        text-align: right;
    }
    .cotainer .item-box .item .under{
        color: #588bf8;
    }
    .cotainer .item-box .item:last-child .item-right{
        border-bottom: none;
    }
    .cotainer .item-box .item .remark{
        color: #fff;
        font-size: .36rem;
        padding: .24rem 0 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/cbjl.vue